import { init, track, type PlausibleEventOptions } from "@plausible-analytics/tracker";

init({
	domain: "kino-thun.ch",
});

export function trackEvent(eventName: string, options: PlausibleEventOptions = {}) {
	try {
		track(eventName, options);
	} catch { }
}
